import React, { useContext, useEffect, useRef, useState } from 'react'
import { UserContext } from '../../App'
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ShippingOptions } from '../../components/dashboard/newBook/shippingOptions';
import { ChooseCondition } from '../../components/dashboard/newBook/chooseCondition';
import { ChoosePrice } from '../../components/dashboard/newBook/choosePrice';
import { FaArrowRightLong } from "react-icons/fa6";
import { FaArrowLeftLong } from "react-icons/fa6";
import { LoadingFull, LoadingOverlay } from '../../components/loading';
import { ChooseImages } from '../../components/dashboard/newBook/chooseImages';
import { Helmet } from 'react-helmet-async';
import { BookDetails } from '../../components/dashboard/newBook/bookDetails';
import AllForms from '../../components/login/allForms';
import { Stepper } from '../../components/dashboard/newBook/elements/stepper';
import Phone from '../../components/dashboard/verify/phone';
import Bank from '../../components/dashboard/verify/bank';
import { useNewBook } from '../../components/dashboard/newBook/functions/useNewBook';
import VerifyPhone from '../../components/dashboard/verify/verifyPhone';
import { IoSearchSharp } from "react-icons/io5";
import Faq from '../../components/dashboard/verify/faq';
import AdsComponent from '../../components/adsComponent';

export default function NewBook() {

  const { auth, user, setUser } = useContext(UserContext)
  const token = localStorage.getItem('token')

  const [load, setLoad] = useState(false);
  const { updateAddress, address, setAddress, error_address, setError_Address, updatePhone, phone, setPhone, error_phone, setError_Phone } = useNewBook({ setLoad })
  const [error_condition, setError_Condition] = useState('');
  const [error_price, setError_Price] = useState('');
  const [error_book, setError_Book] = useState('');
  const [error_image, setError_Image] = useState('');
  const [error_bank, setError_Bank] = useState('');
  const [imageFiles, setImageFiles] = useState([])
  const [images, setImages] = useState([])
  const [book, setBook] = useState({});
  const [loadingBook, setLoadingBook] = useState(false);
  const [condition, setCondition] = useState(0);
  const [desc, setDesc] = useState('')
  const [price, setPrice] = useState();
  const [formattedPrice, setFormattedPrice] = useState(0);
  const [pickup, setPickup] = useState(typeof user !== 'undefined' ? user.pickup : true)
  const navigate = useNavigate()
  const [currentStep, setCurrentStep] = useState(0)
  const NUMBER_OF_STEPS = 3
  const [searchParams, setSearchParams] = useSearchParams();

  // Opdater currentStep når get parametret ændrer sig
  useEffect(() => {
    if (searchParams.get("currentStep") !== null) {
      setCurrentStep(Number(searchParams.get("currentStep")))
    } else {
      setCurrentStep(0)
    }
  }, [searchParams.get("currentStep")])

  // Scroll til top ved reload + læs get parametrene
  useEffect(() => {
    window.scrollTo({top: 0, left: 0, behavior: 'auto'})
    if (searchParams.get("currentStep") !== null) {
      setCurrentStep(Number(searchParams.get("currentStep")))
    }
  }, [])

  useEffect(() => {
    if (typeof user !== 'undefined') {
      if (typeof user.phone !== 'undefined') {
        setPhone(user.phone.slice(2))
      }
    }
  }, [user])

  function scrollTo(id) {
    if (id === 'top') {
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
    } else {
      const element = document.getElementById(id);
      if (element) {
        const offset = 75; // Juster denne værdi til ønsket afstand (100-200px)
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
      }
    }
  }

  function addressesAreEqual(a, b) {
    if (!a || !b) return false;
  
    return (
      a.line1 === b.line1 &&
      a.postal_code === b.postal_code &&
      a.city === b.city
    );
  }

  const goToNextStep = async (updatedUser) => {
    let actualUser
    if (!updatedUser) {
      actualUser = user
    } else if (updatedUser.nativeEvent) {
      actualUser = user
    } else {
      actualUser = updatedUser
    }
    let hasScrolled = false
    if (currentStep === 0) {
      if (Object.keys(book).length !== 0) {
        setError_Book('')
        if (imageFiles.length < 1) {
          setError_Image('Du skal mindst tilføje ét billede')
          if (!hasScrolled) {
            scrollTo('uploadImage')
            hasScrolled = true
          }
        } else {
          setError_Image('')
        }
        if (condition === 0) {
          setError_Condition('Angiv venligst bogens stand')
          if (!hasScrolled) {
            scrollTo('setCondition')
            hasScrolled = true
          }
        } else {
          setError_Condition('')
        }
        if (typeof price === 'undefined') {
          setError_Price('Angiv venligst en pris')
          if (!hasScrolled) {
            scrollTo('setPrice')
            hasScrolled = true
          }
        } else if (price/100 < 50) {
          setError_Price('Mindste pris er 50 kr.')
          if (!hasScrolled) {
            scrollTo('setPrice')
            hasScrolled = true
          }
        } else {
          setError_Price('')
        }
        if (!hasScrolled) {
          setSearchParams(searchParams => {
            searchParams.set("currentStep", currentStep === NUMBER_OF_STEPS - 1 ? currentStep : currentStep + 1)
            return searchParams
          })
          setCurrentStep(prev => prev === NUMBER_OF_STEPS - 1 ? prev : prev + 1)
        }
      } else {
        setError_Book('Du skal vælge en bog')
        scrollTo('top')
      }
    } else if (currentStep === 1) {
      if (typeof address !== 'undefined' && ('line1' && 'postal_code' && 'city' in address)) {
        if (typeof actualUser !== 'undefined') {
          if (!addressesAreEqual(actualUser.address, address)) {
            await updateAddress()
          }
          if (actualUser.verified) {
            if (Object.keys(actualUser.stripe.external_accounts).length !== 0 && actualUser.verified_phone === true) {
              handleNewBook(actualUser)
            } else {
              setSearchParams(searchParams => {
                searchParams.set("currentStep", 3)
                return searchParams
              })
              setCurrentStep(3)
            }
          } else {
            setSearchParams(searchParams => {
              searchParams.set("currentStep", 2)
              return searchParams
            })
            setCurrentStep(2)
          }
        } else {
          setSearchParams(searchParams => {
            searchParams.set("currentStep", 2)
            return searchParams
          })
          setCurrentStep(2)
        }
      } else {
        setError_Address('Indtast din adresse')
        scrollTo('address')
      }
    } else if (currentStep === 2) {
      if (Object.keys(actualUser.stripe.external_accounts).length !== 0 && actualUser.verified_phone === true) {
        handleNewBook(actualUser)
      } else {
        setSearchParams(searchParams => {
          searchParams.set("currentStep", 3)
          return searchParams
        })
        setCurrentStep(3)
      }
    } else if (currentStep === 3) {
      if (phone.length === 8) {
        if (Object.keys(actualUser.stripe.external_accounts).length !== 0) {
          if (typeof actualUser.phone !== 'undefined' && actualUser.phone.slice(2) === phone) {
            if (actualUser.verified_phone) {
              handleNewBook(actualUser)
            } else {
              setSearchParams(searchParams => {
                searchParams.set("currentStep", 4)
                return searchParams
              })
              setCurrentStep(4)
            }
          } else {
            updatePhone({goToNextStep})
          }
        } else {
          setError_Bank('Tilføj en udbetalingskonto')
          scrollTo('bank')
        }
      } else {
        setError_Phone('Indtast et gyldigt telefonnummer')
        scrollTo('top')
      }
    } else if (currentStep === 4) {
      if (typeof actualUser.phone !== 'undefined' && actualUser.verified_phone === true) {
        handleNewBook(actualUser)
      } else {
        setSearchParams(searchParams => {
          searchParams.set("currentStep", 3)
          return searchParams
        })
        setCurrentStep(3)
      }
    }
  }

  const goToPreviousStep = () => {
    if (currentStep === 3 && typeof user !== 'undefined') {
      setSearchParams(searchParams => {
        searchParams.set("currentStep", 1)
        return searchParams
      })
      setCurrentStep(1)
    } else {
      setSearchParams(searchParams => {
        searchParams.set("currentStep", currentStep <= 0 ? currentStep : currentStep - 1)
        return searchParams
      })
      setCurrentStep(prev => prev <= 0 ? prev : prev - 1)
    }
  }

  function getCondition(data) {
    setCondition(data);
    setError_Condition('')
  }

  function getPrice(price) {
    setFormattedPrice(price);
    let withoutMask = price.toString().replace(/[^\d,-]/g, '')
    withoutMask = withoutMask.replace(/,/g, '.')
    let asNumber = (Math.round(Number(withoutMask) * 100) / 100).toFixed(2)
    asNumber = asNumber.toString().replace(/\./g, '')
    setPrice(Number(asNumber))
    setError_Price('')
  }
  
  const handleIsbnChange = (e) => {
    setError_Book('')
    let value = e.target.value;
  
    value = value.replace(/[^0-9\-]/g, '');
    value = value.replace(/--+/g, '-');
    e.target.value = value;
  };

  function searchIsbn(isbn) {
    setError_Book('')
    setLoadingBook(true)
    axios({
      method: 'post',
      url: '/api/searchIsbn',
      data: {
          isbn
      }
    })
    .then(response => {
      setBook(response.data);
      scrollTo('bookDetails')
      setLoadingBook(false)
    })
    .catch(error => {
      setLoadingBook(false)
      setError_Book('Bogen blev ikke fundet')
      console.log(error);
    });
  }

  async function handleNewBook(updatedUser) {
    let actualUser
    if (!updatedUser) {
      actualUser = user
    } else if (updatedUser.nativeEvent) {
      actualUser = user
    } else {
      actualUser = updatedUser
    }
    if (Object.keys(book).length !== 0) {
      setError_Book('')
      if (condition === 0) {
        setError_Condition('Angiv venligst bogens stand')
      } else {
        setError_Condition('')
      }
      if (typeof price === 'undefined') {
        setError_Price('Angiv venligst en pris')
      } else if (price/100 < 50) {
        setError_Price('Mindste pris er 50 kr.')
      } else {
        setError_Price('')
      }
      if (imageFiles.length < 1) {
        setError_Image('Du skal mindst tilføje ét billede')
      } else {
        setError_Image('')
      }
      if (typeof address === 'undefined' || !('line1' && 'postal_code' && 'city' in address)) {
        setError_Address('Indtast din adresse')
      } else {
        setError_Address('')
      }
      if (typeof actualUser !== 'undefined' && actualUser.verified) {
        if (phone.length !== 8) {
          setError_Phone('Indtast et gyldigt telefonnummer')
        } else {
          setError_Phone('')
        }
        if (actualUser.verified_phone !== true) {
          setError_Phone('Indtast din bekræftelseskode')
        } else {
          setError_Phone('')
        }
        if (Object.keys(actualUser.stripe.external_accounts).length === 0) {
          setError_Bank('Tilføj en udbetalingskonto før du sælger en bog')
        } else {
          setError_Bank('')
        }
      }
      if (condition !== 0 && typeof price !== 'undefined' && price >= 50 && imageFiles.length > 0) {
        if (typeof address !== 'undefined' && ('line1' && 'postal_code' && 'city' in address)) {
          if (typeof actualUser !== 'undefined' && actualUser.verified) {
            if (typeof actualUser.phone !== 'undefined' && actualUser.verified_phone === true && Object.keys(actualUser.stripe.external_accounts).length !== 0) {
              if (actualUser.stripe.payouts_enabled) {
                const bookId = book['bookId']
                const stand = condition
                const token = localStorage.getItem('token')
                if (token) {
                  var formData = new FormData()
                  for (let i = 0; i < imageFiles.length; i++) {
                    formData.append('bookImages[]', imageFiles[i])
                  }
                  formData.append('bookId', bookId)
                  formData.append('stand', stand)
                  formData.append('desc', desc)
                  formData.append('price', price)
                  formData.append('pickup', pickup)
                  setLoad(true)
                  try {

                    const response = await axios({
                      method: 'post',
                      url: '/api/newBook',
                      data: formData,
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    })

                    navigate('/dashboard/bøger')
                    setLoad(false)
                    
                  } catch (error) {
                    setLoad(false)
                  }
                } else {
                  return navigate('/login')
                }
              } else {
                setSearchParams(searchParams => {
                  searchParams.set("currentStep", 3)
                  return searchParams
                })
                setCurrentStep(3)
              }
            } else {
              setSearchParams(searchParams => {
                searchParams.set("currentStep", 3)
                return searchParams
              })
              setCurrentStep(3)
            }
          } else {
            setSearchParams(searchParams => {
              searchParams.set("currentStep", 2)
              return searchParams
            })
            setCurrentStep(2)
          }
        } else {
          setSearchParams(searchParams => {
            searchParams.set("currentStep", 1)
            return searchParams
          })
          setCurrentStep(1)
        }
      } else {
        setSearchParams(searchParams => {
          searchParams.set("currentStep", 0)
          return searchParams
        })
        setCurrentStep(0)
      }
    } else {
      setError_Book('Du skal vælge en bog')
      setSearchParams(searchParams => {
        searchParams.set("currentStep", 0)
        return searchParams
      })
      setCurrentStep(0)
    }
  }

  return (
    <>
      <Helmet>
        <title>BogBanken.dk | Sælg bog</title>
        <meta name="description" content="Har du gamle studiebøger? Sælg dem hurtigt og nemt til nye studerende og tjen penge på dine brugte lærebøger." />
      </Helmet>
      {(load) ?
        <div className="fixed h-lvh w-full z-20">
          <LoadingOverlay />
        </div>
      :
        ""}
      <div className="relative flex justify-around gap-x-5">
        <div className="hidden md:block h-lvh flex-1 w-auto px-2 lg:px-5 xl:px-10 pt-[100px] pb-[40px] sticky top-0">
          <div className="w-full h-full bg-gray-200 sticky top-[100px]">
            <p>Reklame</p>
          </div>
        </div>
        <div id="container" className="innerContainer md:w-[600px] lg:w-[700px] flex gap-x-10 min-h-lvh py-[100px]">
          <div className="w-full">
            <div className="flex flex-col justify-between gap-y-8 h-full">
              <div className="h-full flex flex-col gap-y-8">
                <div className="title text-lg xl:text-xl font-bold uppercase space-y-4">
                  <h2>Opret ny bog</h2>
                  <Stepper currentStep={currentStep} />
                </div>
                <div className="flex flex-col justify-between h-full">
                  {currentStep === 4 ?
                    <VerifyPhone goToNextStep={goToNextStep} />
                  : currentStep === 3 ?
                    <div className="space-y-10">
                      <Phone error={error_phone} setError={setError_Phone} phone={phone} setPhone={setPhone} />
                      <Bank error={error_bank} setError={setError_Bank} />
                      <Faq quests={[1, 2, 3]} />
                    </div>
                  : currentStep === 2 ?
                    typeof user === 'undefined' || !user.verified ?
                      <AllForms address={address} setAddress={setAddress} goToNextStep={goToNextStep} />
                    :
                      <div className="h-full">
                        <LoadingFull />
                      </div>
                  : currentStep === 1 ?
                    <ShippingOptions error={error_address} setError={setError_Address} pickup={pickup} setPickup={setPickup} address={address} setAddress={setAddress} />
                  :
                    <div className="flex flex-col gap-y-10">
                      <div className="flex flex-col gap-y-10 flex-[3]">
                        <div className="flex flex-col gap-2" id="findBook">
                          <div className="">
                            <label for="bog" className="block text-sm font-medium text-gray-900">Indtast ISBN</label>
                            <p className="text-sm text-neutral-500">Med eller uden bindestreg</p>
                          </div>
                          {(error_book !== '') ? <h2 className="text-sm font-medium text-gray-900 text-red-500">{error_book}</h2> : ""}
                          <div className="relative flex group">
                              <input id="isbn" type="text" autoFocus={Object.keys(book).length === 0} inputMode="numeric" onChange={handleIsbnChange} onKeyDown={(e) => e.key === 'Enter' ? searchIsbn(e.target.value) & e.target.blur() : ""} onBlur={(e) => e.target.value.length > 0 && searchIsbn(e.target.value)} autoComplete='off' className="tracking-[.35em] placeholder:tracking-[0] block w-full ring-1 ring-inset -mr-[1px] focus:-mr-[2px] ring-neutral-300 focus:ring-emerald-700 focus:outline-none focus:ring-2 p-4 ps-5 md:ps-10 text-base text-gray-900 placeholder:text-neutral-500" placeholder="Indtast ISBN ..." required />
                              <div className="bg-size-200 bg-pos-0 hover:bg-pos-100 transition-all duration-150 ease-in-out text-white bg-gradient-to-r from-emerald-600 to-emerald-700 p-2 h-full aspect-[1/1] cursor-pointer flex justify-center items-center text-2xl" onClick={() => searchIsbn(document.getElementById('isbn').value)}><IoSearchSharp /></div>
                          </div>
                          {/*<p className="text-sm">Kan du ikke finde din bog? <span className="underline cursor-pointer">Indtast bogoplysninger manuelt</span></p>*/}
                        </div>
                        <BookDetails book={book} loadingBook={loadingBook} />
                      </div>
                      
                      {Object.keys(book).length !== 0 &&
                        <>
                          <ChooseImages imageFiles={imageFiles} setImageFiles={setImageFiles} images={images} setImages={setImages} error={error_image} setError={setError_Image} scrollTo={scrollTo} />

                          <ChooseCondition setCondition={getCondition} condition={condition} setDesc={setDesc} desc={desc} error={error_condition} setError={setError_Condition} />

                          <ChoosePrice setPrice={getPrice} formattedPrice={formattedPrice} price={price} error={error_price} setError={setError_Price} />
                        </>}
                    </div>
                  }
                </div>
              </div>
              {Object.keys(book).length !== 0 &&
                <div className={"items-center w-full flex justify-between z-10 pointer-events-none" + (currentStep === 1 || (currentStep === 2 && (typeof user === 'undefined' || !user.verified)) ? " relative bottom-0" : " sticky bottom-10")}>
                  <button className={"sticky w-fit mr-auto group justify-center sm:min-w-40 flex items-center gap-2 bg-gradient-to-r from-emerald-600 to-emerald-700 bg-pos-0 bg-size-200 hover:bg-pos-100 text-white px-4 sm:px-8 py-2 pointer-events-auto" + (currentStep === 0 ? " hidden" : "")} onClick={goToPreviousStep}>
                    <FaArrowLeftLong className="text-sm group-hover:-translate-x-2 transition-[]" />
                    Tilbage
                  </button>
                  <button className={"sticky w-fit ml-auto group justify-center sm:min-w-40 flex items-center gap-2 bg-gradient-to-r from-emerald-600 to-emerald-700 bg-pos-0 bg-size-200 hover:bg-pos-100 text-white px-4 sm:px-8 py-2 pointer-events-auto" + ((currentStep === 2 && (typeof user === 'undefined' || !user.verified)) || (currentStep === 4) ? " hidden" : "")} onClick={goToNextStep}>
                    Fortsæt
                    <FaArrowRightLong className="text-sm group-hover:translate-x-2 transition-[]" />
                  </button>
                </div>}
            </div>
          </div>
        </div>
        <div className="hidden md:block h-lvh flex-1 w-auto px-2 lg:px-5 xl:px-10 pt-[100px] pb-[40px] sticky top-0">
          <div className="w-full h-full bg-gray-200 sticky top-[100px]">
            <p>Reklame</p><AdsComponent dataAdSlot='6111982701' />
          </div>
        </div>
      </div>
    </>
  )
}